import { useReducer, useState, useEffect } from 'react'
import { fetchSuggestions } from './api/httpHandlers'
import { appReducer, initalState } from './appState'
import StepMapper from './components/steps/StepMapper'

export default function App() {
  const [state, dispatch] = useReducer(appReducer, initalState)
  const { step } = state
  const [hasFetchError, setHasFetchError] = useState(false)
  useEffect(() => {
    async function fetchData() {
      try {
        const result = await fetchSuggestions(state.userData)
        if (result.successful) {
          dispatch({ type: 'fetchingDone', data: result.data })
        } else {
          throw new Error('Something went wrong')
        }
      } catch (err) {
        setHasFetchError(true)
      }
    }
    if (state.isFetching) {
      fetchData().catch(() => {
        dispatch({ type: 'setHasAppError', value: true })
      })
    }
  }, [state])

  if (hasFetchError || state.hasAppError) {
    throw new Error('Something went wrong!')
  }

  return (
    <main
      className={`fixed min-h-full min-w-full justify-center antialiased ${
        step === 'start' ? 'bg-black' : 'bg-white'
      }`}
    >
      <div className="mx-auto h-screen max-w-full overflow-y-auto pb-60 md:pb-0">
        <div className="mx-auto flex flex-col">
          <StepMapper state={state} appDispatch={dispatch} />
        </div>
      </div>
    </main>
  )
}
